define('presentation/settings/billing/plans/viewModels/removePlanConfirmationModalViewModel',[
    'common/promises/promiseFactory',
    'constants/billingPackageTypeConstants'
], function() {
    return function (planPresentationObject) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');

        self.planPresentationObject = planPresentationObject;
        self.typeI18nKey = ko.pureComputed(() => {
            switch (planPresentationObject.type()) {
                case _billingPackageTypes.liveReceptionist.id:
                    return _billingPackageTypes.liveReceptionist.key;
                case _billingPackageTypes.webChat.id:
                    return _billingPackageTypes.webChat.key;
                case _billingPackageTypes.outboundCalling.id:
                    return _billingPackageTypes.outboundCalling.key;
                default:
                    return "";
            }
        });

        self.submitAction = () => {
            return _promiseFactory.defer((deferredObject) => {
                deferredObject.resolve({isValid: true});
            });
        };

        self.activate = () => {
            return _initialize();
        };

        const _initialize = () => {
            return _promiseFactory.wait();
        };
    };
});
